module.exports = __webpack_public_path__ + "img/strat.98b3782a.svg";